import {
    ODataHeader,
    ODataString,
    ODataDecimal,
    ODataDate,
    ODataBoolean
} from "pbas-vue-components";

import { translateProperty } from '../trans'
import store from '@/store'

const AdminFilesHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        sortable: true,
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/DisplayName", {
            getString: function(item) {
                const lang = store.getters['common/language']
                return translateProperty(item, 'DisplayName', lang.language);
            },
            getHtml: (item, type) => {
                // const lang = store.getters['common/language'];
                // const trans = translateProperty(item, 'PhysicalFile', lang.language);
                // console.log(trans.Path);
                let html = "";
                for (let trans of item.Translations) {
                    html+=`<a href="${trans.PhysicalFile.Path}" target="_blank">${translateProperty(item, 'DisplayName', trans.LanguageCode)}</a><br>`;
                }
                return html;
            }
        }),
        sortable: false,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/PhysicalFile/Path"),
        ssortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/PhysicalFile/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/PhysicalFile/Name"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.category",
        type: new ODataString("Category/Translations[]/Name", {
            getString: function(item) {
                const lang = store.getters['common/language']
                return translateProperty(item.Category, 'Name', lang.language);
            }
        }),
        sortable: false,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Category/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("CategoryId"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Category/Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "components.plancreationwizard.classes",
        type: new ODataString("ClassDownloadFileRelations[]/ClassDownloadCenterFile/Class", {
            getString: function(item) {
                if (item.ClassDownloadFileRelations===null || item.ClassDownloadFileRelations===undefined) {
                    return "";
                }
                return item.ClassDownloadFileRelations.map(o=>o.ClassDownloadCenterFile.Class).join(", ");

            }
        }),
        sortable: false,
        visible: true,
        allowVisibilityChange: true,
        searchable: true
    })
];
export default AdminFilesHeaders;